import { AjudaPopover, Dialog, DialogContent } from "@bookdental/ui";
import { trpc } from "@/lib/trpc";
import { AJUDA_ONBOARDING } from "@/lib/ajuda/dialogos/onboarding";
import { OnboardingWizard } from "./OnboardingWizard";

/**
 * Modal bloqueante de onboarding. Full-screen no mobile, card no desktop.
 * Apos sucesso, invalida me.current → AuthProvider refetcha → modal desmonta.
 */
export function OnboardingModal() {
  const utils = trpc.useUtils();

  const handleComplete = () => {
    utils.me.current.invalidate();
  };

  return (
    <Dialog open onOpenChange={() => {}}>
      <DialogContent
        hideClose
        className="flex h-[100dvh] max-h-[100dvh] w-full max-w-3xl flex-col gap-0 overflow-hidden border-0 bg-white p-0 sm:h-auto sm:max-h-[92vh] sm:rounded-3xl sm:border sm:border-zinc-200 sm:shadow-2xl"
        onEscapeKeyDown={(e) => e.preventDefault()}
        onPointerDownOutside={(e) => e.preventDefault()}
        onInteractOutside={(e) => e.preventDefault()}
      >
        <div className="flex-1 overflow-y-auto p-5 sm:p-10">
          <OnboardingWizard onComplete={handleComplete} />
        </div>
        {/* O título é do wizard (vale pros dois passos); o "?" fica no canto, livre — o modal não tem X. */}
        <AjudaPopover className="absolute right-3 top-3">{AJUDA_ONBOARDING.cadastroInicial}</AjudaPopover>
      </DialogContent>
    </Dialog>
  );
}
